import React from 'react';
import { Instagram, Mail, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-zinc-950 py-24 md:py-32 px-6 border-t border-zinc-900" data-id="element-22" data-mp="3gfiv8kpoaff6">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-23" data-mp="32o4deh7i4k9p">
        <p className="font-mono text-[11px] md:text-xs uppercase tracking-[0.4em] text-white/40 font-light" data-id="element-24" data-mp="32m1c310wf4po">
          El océano te está esperando
        </p>

        <h2 className="mt-10 md:mt-12 font-heading text-2xl md:text-4xl font-medium uppercase tracking-[0.15em] text-white" data-id="element-25" data-mp="3ugbpd4c2b8hr">
          Buceo y Navegación
        </h2>

        <div className="mt-12 md:mt-16 flex items-center gap-8" data-id="element-26" data-mp="3levi35gjnmhr">
          <a href="https://wa.me/5491122836110" target="_blank" rel="noopener noreferrer" className="text-zinc-500 hover:text-blue-400 transition-colors" aria-label="WhatsApp" data-id="element-27" data-mp="3lgonyijc22op">
            <MessageCircle className="w-5 h-5" strokeWidth={1.5} data-id="element-28" data-mp="2ezbag0sgpc5l" />
          </a>
          <a href="https://instagram.com/buceoynavegacion" target="_blank" rel="noopener noreferrer" className="text-zinc-500 hover:text-blue-400 transition-colors" aria-label="Instagram" data-id="element-29" data-mp="3l90nfv0aswyq">
            <Instagram className="w-5 h-5" strokeWidth={1.5} data-id="element-30" data-mp="3v5n6ce92ddy4" />
          </a>
          <a href="mailto:buceoynavegacion@gmail.com" className="text-zinc-500 hover:text-blue-400 transition-colors" aria-label="Email" data-id="element-31" data-mp="3q7264ettau9o">
            <Mail className="w-5 h-5" strokeWidth={1.5} data-id="element-32" data-mp="335slg3f1hfy" />
          </a>
        </div>
      </div>
    </footer>;
}